import { Point } from "pixi.js";
import { Objective } from "./Objective";
import { EntityStatic, EntityAnim } from "./../map/Entity";
import { Obstacle } from "../map/Obstacle";
import { Command } from "./Command";
import { app } from "./../";

const api = {
    dummy: () => true,

    pushToStack(scopeId) {
        this.pushToStack(scopeId);
        return true;
    },

    popFromStack(scopeId) {
        this.popFromStack(scopeId);
        return true;
    },

    runBlock(blockId, scopeId) {
        if (this.runner.blocks.has(blockId)) {
            if (scopeId) this.queue.unshift(Command.fromString("popFromStack(" + scopeId + ")"));
            this.queue.unshift.apply(this.queue, this.runner.blocks.get(blockId));
            if (scopeId) this.queue.unshift(Command.fromString("pushToStack(" + scopeId + ")"));
        } else if (blockId !== "null") {
            console.warn("Failed to find block " + blockId + ".");
        }

        return true;
    },

    executeBlock(blockId, scopeId) {
        /* if (this.runner.blocks.has(blockId)) {
            let queue = [];
            if (scopeId) queue.unshift(Command.fromString('popFromStack(' + scopeId + ')'));
            queue.unshift.apply(queue, this.runner.blocks.get(blockId));
            if (scopeId) queue.unshift(Command.fromString('pushToStack(' + scopeId + ')'));

            let newThread = new Thread(blockId + '@' + Math.floor(Math.random() * 999999999) + 1, this, false);
            newThread.queue = queue;
            this.threads.set(newThread.id, newThread);
            newThread.run();
        } else if (blockId !== 'null') {
            console.warn('Failed to find block ' + blockId + '.');
        } */

        this.runner.runOnThread(
            blockId + "@" + Math.floor(Math.random() * 999999999) + 1,
            scopeId,
            blockId,
            false
        );

        return true;
    },

    panToTile(tileX, tileY) {
        // Tell camera to pan to tile.

        return false;
    },

    panToEntity(entityId) {
        let entity = this.runner.findEntity(entityId);
        this.runner.panCameraToXY(entity.position, () => {
            this.resume();
        });

        return false;
    },

    addEntity(entityId, textureId, tileX, tileY) {
        if (arguments.length !== 4) {
            console.warn("addEntity: Incorrect number of arguments");
            return true;
        }

        let entity = new EntityStatic(
            entityId,
            this.runner.assets[textureId],
            Math.trunc(tileX),
            Math.trunc(tileY)
        );
        let worldPos = this.runner.tilemap.localToWorldXY(entity.tilePos.x, entity.tilePos.y);
        entity.position.copyFrom(worldPos);
        entity.setOffset(this.runner.tilemap.tileOffset);

        this.runner.tilemap.addEntity(entity);
        this.runner.entities.set(entity.id, entity);

        return true;
    },

    addEntityAnim(animId, tileX, tileY) {
        if (arguments.length !== 3) {
            console.warn("addEntityAnim: Incorrect number of arguments");
            return true;
        }

        if (!this.runner.animExtras[animId]) return true;

        tileX = this.runner.replaceSpecials(tileX);
        tileY = this.runner.replaceSpecials(tileY);

        // Trunc after specials as some specials are string replacements.
        tileX = Math.trunc(tileX);
        tileY = Math.trunc(tileY);

        let entity = new EntityAnim(animId, this.runner.animExtras[animId], tileX, tileY);
        //entity.position.set(x, y);
        let worldPos = this.runner.tilemap.localToWorldXY(tileX, tileY);
        entity.position.copyFrom(worldPos);
        entity.setOffset(this.runner.tilemap.tileOffset);

        this.runner.tilemap.addEntity(entity);
        this.runner.entities.set(entity.id, entity);
        this.runner.aiController.addEntity(entity);

        return true;
    },

    removeEntity(entityId) {
        let entity = this.findEntity(entityId);
        console.log(entity);
        this.runner.deleteEntity(entity);
        this.runner.aiController.removeEntity(entity);

        return true;
    },

    adjustOffset(entityId, offsetX, offsetY) {
        let entity = this.findEntity(entityId);
        if (entity)
            entity.setOffset(
                new Point(
                    this.runner.tilemap.tileOffset.x + Math.trunc(offsetX),
                    this.runner.tilemap.tileOffset.y + Math.trunc(offsetY)
                )
            );

        return true;
    },

    setParentEntity(childId, parentId, offsetX, offsetY) {
        let child = this.findEntity(childId);
        let parent = this.findEntity(parentId);

        if (child && parent) {
            parent.addChild(child);
            child.x = offsetX;
            child.y = offsetY;
            child.setOffset(
                new Point(this.runner.tilemap.tileOffset.x, this.runner.tilemap.tileOffset.y)
            );
        }

        return true;
    },

    playAnim(entityId, animName, shouldLoop, blockId) {
        let entity = this.findEntity(entityId);

        if (entity && entity.isAnim) {
            if (arguments.length === 4) {
                let event = {
                    end: () => {
                        this.runner.runOnThread(
                            blockId + "@" + Math.floor(Math.random() * 999999999) + 1,
                            null,
                            blockId,
                            false
                        );
                        entity.clearListeners();
                    }
                };
                entity.addEvents(event);
            }

            entity.playAnim(animName, shouldLoop == "true");
        }

        return true;
    },

    moveTo(entityId, tileX, tileY, tweenTime) {
        let entity = this.findEntity(entityId);

        // If we haven't found an entity just try and continue.
        if (!entity) return true;

        let worldPos = this.runner.tilemap.localToWorldXY(tileX, tileY);
        app.tween(entity)
            .to({ x: worldPos.x, y: worldPos.y }, tweenTime)
            .call(() => this.resume());

        return false;
    },

    follow(entityId, targetId) {
        let entity = this.findEntity(entityId);
        let target = this.findEntity(targetId);

        if (entity && target) {
            entity.target = {
                entity: target
            };
        }

        return true;
    },

    unFollow(entityId) {
        let entity = this.findEntity(entityId);
        let target = this.findEntity(targetId);

        if (entity && target) {
            entity.target = {
                entity: target
            };
        }

        return true;
    },

    addObstacle(obstacleId, textureId, effectType, tileX, tileY) {
        if (arguments.length !== 5) {
            console.warn("addObstacle: Incorrect number of arguments");
            return true;
        }

        let obstacle = new Obstacle(
            obstacleId,
            this.runner.assets[textureId],
            effectType.toUpperCase(),
            Math.trunc(tileX),
            Math.trunc(tileY)
        );
        let worldPos = this.runner.tilemap.localToWorldXY(obstacle.tilePos.x, obstacle.tilePos.y);
        obstacle.position.copyFrom(worldPos);
        obstacle.setOffset(this.runner.tilemap.tileOffset);
        obstacle.setDestroyCB(() => {
            app.sound.play("14-banana-peel");
            this.runner.tilemap.removeObstacle(obstacle);
            this.runner.entities.delete(obstacle.id);
        });

        this.runner.tilemap.addObstacle(obstacle);
        this.runner.entities.set(obstacle.id, obstacle);

        return true;
    },

    removeObstacle(obstacleId) {
        // Find obstacle.
        // Remove obstacle.

        return true;
    },

    addObjective(entityId, blockId, marker) {
        // Check if id valid. See if entity with id exists.
        let entity = this.runner.findEntity(entityId);

        if (arguments.length === 1) blockId = null;

        /* if (arguments.length > 1 && !this.runner.blocks.has(blockId)) {
            console.warn('Failed to add objective ' + entityId + ' due to invalid blockId of ' + blockId);
            return true;
        } */

        // TODO: guard and setup marker.
        if (arguments.length < 3) marker = false;

        let obj = new Objective(entityId, blockId, marker, entity);
        this.runner.addObjective(obj);
        /*         this.runner.on('objective-' + obj.id, () => {
                    // Remove the objective now it is complete and run its code block.
                    this.objectives.filter(item => item.id === obj.id);
                    api.runBlock(obj.blockId);
                }, this); */

        if (marker && entity && this.runner.assets["bubble"] && this.runner.assets[marker]) {
            this.runner.speakPermanent(
                entity,
                this.runner.assets["bubble"],
                this.runner.assets[marker]
            );
        }

        return true;
    },

    removeObjective(entityId) {
        console.log("Inside spript api");
        let entity = this.findEntity(entityId);
        console.log(entityId);
        console.log(entity);

        if (entity) {
            console.log("Got entity");
            this.runner.speakClose(entity);
        }
    },

    showObjective(id, waitTime) {
        let objective = this.runner.findObjectiveById(id);

        // If we can't find an objective we just won't show it.
        if (!objective || !objective.entity) return true;

        if (!this.runner.sharedData.locked) this.runner.player.lock(true);
        this.runner.glanceAt(objective.entity.position, waitTime * 1000, () => {
            if (!this.runner.sharedData.locked) this.runner.player.lock(false);
            this.resume();
        });

        return false;
    },

    cutscene(inProgress) {
        this.runner.player.lock(inProgress == "true");
        this.runner.sharedData.locked = inProgress;
        return true;
    },

    talk(entityId, bubbleIcon, displayTime, waitTime) {
        let entity = this.findEntity(entityId);

        // Check we have everything we need to talk.
        if (entity && this.runner.assets["bubble"] && this.runner.assets[bubbleIcon]) {
            this.runner.speak(
                entity,
                this.runner.assets["bubble"],
                this.runner.assets[bubbleIcon],
                displayTime * 1000,
                waitTime * 1000,
                () => {
                    this.resume();
                }
            );
        }

        return false;
    },

    unlockPlayer() {
        this.runner.play.lock(false);
        return true;
    },

    wait(waitTime) {
        app.tween(this)
            .wait(waitTime)
            .call(() => this.resume());
        return false;
    },

    haltUntil(...args) {
        this.runner.halts.push(...args);
        return false;
    },

    playSound(soundId, delayTime) {
        app.sound.play(soundId);
        return true;
    },

    teleport(targetX, targetY) {
        let worldPos = this.runner.tilemap.localToWorldXY(Math.trunc(targetX), Math.trunc(targetY));

        this.runner.player.tilePosition = new Point(Math.trunc(targetX), Math.trunc(targetY));
        // this.runner.camera.snap(worldPos.x, worldPos.y, { removeOnComplete: true, removeOnInterrupt: false, interrupt: true, topLeft: false });
        this.runner.camera.pausePlugin("follow");
        this.runner.camera.moveCenter(worldPos.x, worldPos.y);
        this.runner.camera.resumePlugin("follow");

        return true;
    }
};

class _ScriptAPI {
    constructor() {
        this.functions = new Map();

        for (const key in api) {
            if (Object.prototype.hasOwnProperty.call(api, key)) {
                this.functions.set(key, api[key]);
            }
        }

        Object.assign(this, api);
    }

    getFuncByName(command) {
        if (this.functions.has(command)) return this.functions.get(command);
        console.warn("Failed to find command " + command + ".");
        return this.functions.get("dummy");
    }
}

export let ScriptAPI = new _ScriptAPI();
